const presence = ['Remote', 'In-Person'];
const durationKind = ['Job', 'Event', 'Ongoing', 'AmeriCorps'];

export { presence, durationKind };
